export function salesRepSearch() {
  return {
    zipCode: '',
    loading: false,
    selectedRep: null,
    error: '',

    async searchRep() {
      // Reset state
      this.error = '';
      this.selectedRep = null;

      // Validate zip code
      if (!this.zipCode || this.zipCode.length !== 5 || !/^\d+$/.test(this.zipCode)) {
        this.error = 'Please enter a valid 5-digit zip code.';
        return;
      }

      this.loading = true;

      try {
        const response = await fetch(`/api/sales-reps/search?zip=${this.zipCode}`);
        const data = await response.json();

        if (data.salesRep) {
          this.selectedRep = data.salesRep;
          
          // Smooth scroll to results after a short delay to allow DOM update
          this.$nextTick(() => {
            setTimeout(() => {
              const resultsSection = this.$refs.results;
              if (resultsSection) {
                resultsSection.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }, 100);
          });
        } else {
          this.error = 'No sales representative found for this zip code.';
        }
      } catch (error) {
        console.error('Error searching for sales rep:', error);
        this.error = 'Error searching for sales representative. Please try again.';
      } finally {
        this.loading = false;
      }
    },

    closeModal() {
      this.selectedRep = null;
    }
  };
}